class ReadMore {
  constructor() {
    this.settings = {
      link: '.more-link',
      text: '.more-text',
    };
  }

  init() {
    const $links = $(this.settings.link);
    $links.on({
      click(e) {
        e.preventDefault();
        $(this).addClass('d-none');
        $($(this).attr('href')).toggleClass('active');
      },
    });
  }
}
export default ReadMore;
